import React, { useState } from 'react';
import { PhotoIcon } from '@heroicons/react/24/outline';
import { patchFormContent } from '../../../../../../services/forms/formContentService';
import CustomDialog from '../../../../../../components/modals/CustomDialog/CustomDialog';
import Upload from '../../../../../../components/Upload/Upload';
import { useFormEdit } from '../../FormEditContext';

export default function UploadImageModal({ uuid, update, setUploading }) {
  const [open, setOpen] = useState(false);
  const { reportError } = useFormEdit();
  return (
    <>
      <PhotoIcon
        className='h-11 min-w-fit cursor-pointer rounded-full p-2.5 hover:bg-slate-100'
        onClick={() => {
          setOpen(true);
        }}
      />
      <CustomDialog
        isOpen={open}
        closeModal={() => setOpen(false)}
        children={
          <div>
            <Upload
              accept='image/png, image/gif, image/jpeg'
              setFile={(file) => {
                const body = new FormData();
                body.append('attachment_img', file);
                setUploading(true);
                patchFormContent(uuid, body)
                  ?.then(() => {
                    update()?.finally(() => {
                      setUploading(false);
                    });
                  })
                  ?.catch((err) => {
                    setUploading(false);
                    reportError(err, 'Не удалось загрузить картинку');
                  });
                setOpen(false);
              }}
            />
          </div>
        }
      />
    </>
  );
}
